module.exports = __webpack_public_path__ + "img/text-center.3f77737e.svg";